// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__oXLA8","textarea":"Textarea_textarea__ZlhGe"};